import React from "react";
import { Link } from "react-router-dom";
import { TbMail, TbPhone } from "react-icons/tb";
import "./Footer.css";

export default function Footer() {
    return (
        <footer className="app-footer" role="contentinfo">
            <div className="app-footer__glow" aria-hidden="true" />

            <div className="app-footer__inner">
                <div className="app-footer__grid">
                    <section
                        className="app-footer__card"
                        aria-labelledby="footer-kontakt"
                    >
                        <h2 className="app-footer__cardTitle" id="footer-kontakt">
                            Kontakt
                        </h2>

                        <a
                            className="app-footer__link"
                            href="mailto:info@pandabit.si"
                        >
                            <span className="app-footer__icon" aria-hidden="true">
                                <TbMail />
                            </span>
                            <span className="app-footer__text">
                                info@pandabit.si
                            </span>
                        </a>

                        <a
                            className="app-footer__link"
                            href="tel:+38631726560"
                        >
                            <span className="app-footer__icon" aria-hidden="true">
                                <TbPhone />
                            </span>
                            <span className="app-footer__text">
                                +386 31 726 560
                            </span>
                        </a>
                    </section>

                    <section
                        className="app-footer__card"
                        aria-labelledby="footer-system"
                    >
                        <h2 className="app-footer__cardTitle" id="footer-system">
                            SISTEM IZVRŠITELJ
                        </h2>

                        <div className="app-footer__secure">
                            <img
                                src="/izvrsitelj.png"
                                alt="IZVRŠITELJ"
                                className="app-footer__imageLogo"
                            />

                            <div className="app-footer__brandText">
                                <span className="app-footer__subtitle">
                                    Profesionalno upravljanje izvršilnih postopkov
                                </span>

                                <Link
                                    to="/profil/navodila"
                                    className="app-footer__docLink"
                                >
                                    <span className="app-footer__docLabel">
                                        Navodila za uporabo / Dokumentacija
                                    </span>
                                    <span
                                        className="app-footer__docArrow"
                                        aria-hidden="true"
                                    >
                                        ↗
                                    </span>
                                </Link>
                            </div>
                        </div>
                    </section>
                </div>

                <div className="app-footer__bottom">
                    <span>© 2026 Izvršitelj. Vse pravice pridržane.</span>
                </div>
            </div>
        </footer>
    );
}